import {Dispatch, FC, SetStateAction, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {FormProvider, useForm} from 'react-hook-form'
import {schemaPermissionByOption} from '../../../../../../../util/validation'
import {yupResolver} from '@hookform/resolvers/yup'
import {savePermissionByOption, editPermissionByOption} from '../../../../../services'
import {PermissionModel} from '../../../../../model'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'
import {InputText} from '../../../../../../../components/UI/Input'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  setIdPermissionList: () => void
  getPermissionByOptionList: () => void
  idPermission?: ''
  detailpermission?: PermissionModel
}

const ModalAddPermission: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getPermissionByOptionList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useCentral()
  const methods = useForm<PermissionModel>({
    resolver: yupResolver(schemaPermissionByOption),
  })
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: {errors},
  } = methods

  useEffect(() => {
    if (idPermission) {
      setValue('opcion', detailpermission?.opcion)

      setValue('codigo', detailpermission?.codigo)
    }
  }, [idPermission])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
  }

  const onSubmit = async (data: PermissionModel) => {
    try {
      if (idPermission) {
        let obj = {
          vistaPermisoOpcionId: idPermission,
          opcion: data?.opcion,
          codigo: data?.codigo,
        }

        const {data: res} = await editPermissionByOption(obj)
        if (!res.error) {
          handleClose()
          getPermissionByOptionList()
        }
      } else {
        let obj = {
          vistaPermisoId: currentTabItem.idToEdit,
          lstOpciones: [
            {
              opcion: data?.opcion,
              codigo: data?.codigo,
            },
          ],
        }

        const {data: res} = await savePermissionByOption(obj)
        if (!res.error) {
          handleClose()
          getPermissionByOptionList()
        }
      }
    } catch (error) {}
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Permiso</h5>
          ) : (
            <h5 className='modal-title'>Agregar Permiso</h5>
          )}
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-12'>
                  <div className='sdx_form_input'>
                    <label className='required form-label'>Módulo</label>
                    <input
                      className='form-control sdx-centra-input-form'
                      value={currentTabItem.aditionalInformation?.option?.applicationName}
                      disabled
                    />
                  </div>
                </div>
                <div className='mb-2 col-12'>
                  <label className='required form-label'>Opción</label>

                  <div className='sdx_form_input'>
                    <input
                      className='form-control sdx-centra-input-form'
                      value={currentTabItem.aditionalInformation?.option?.optionName}
                      disabled
                    />
                  </div>
                </div>
                <div className='mb-2 col-12'>
                  <label className='required form-label'>Código de Permiso</label>
                  <InputText
                    name='codigo'
                    register={register}
                    errors={errors}
                    textPlaceholder='Escribe el código de permiso'
                  />
                </div>
                <div className='mb-2 col-12'>
                  <label className='required form-label'>Permiso</label>
                  <InputText
                    name='opcion'
                    register={register}
                    errors={errors}
                    textPlaceholder='Escribe el permiso'
                  />
                </div>
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddPermission}
